export default {
	jobForms: {
		stepsAndTasksEdit: "Редактирование шагов и задач пакета",
		app: "Приложение",
		template: "Шаблон",
		block: "Заблокировать",
		tasks: "Задачи",
		base: "база",
		allBases: "все базы",
		quanity: "кол-во",
		cancel: "Отменить",
		pathError: "Ошибка в пути задачи",
		noBaseSelectedForTask: "Для одной из задач не выбрана база",
		problemWithAppSelect: "Проблема с выбором приложения",
		tryToDeleteStepAndRecreate: "Попробуйте удалить шаг и создать заново",
		incorrectlyEnteredData: "Неверно введенные данные",
		oneOfParamBaseNameNotdetermined: "Один из параметров краткого имени базы не удалось определить",
		baseWillNotBeAutoSubstituted: "База не будет автоматически подставлена",
		baseNameNoShortName: "Неверно привязана база, выберите другую и заново выберите предыдущую"
	},
	packets: {
		createAppsPacket: "Создать пакет для приложений",
		startOfPackageName: "Начало названия пакета(-ов)",
		apps: "Приложения",
		byt: "быт",
		prom: "пром",
		clean: "очистить",
		withoutBindingToBases: "Пакет для каждого приложения (без привязки баз)",
		packageForEveryBase: "Пакет для каждой базы",
		packageTemplate: "Шаблон для пакета",
		firstPackageStartTime: "Время запуска первого пакета",
		othersPackagesInterval: "Интервал остальных пакетов",
		cancel: "Отменить",
		massPackageDelete: "Множественное удаление пакетов",
		showPackagesByTemplate: "Показать пакеты на основе шаблона",
		packagesByThisTemplate: "Пакеты на основе этого шаблона",
		selectAll: "выбрать все",
		selected: "Выбран",
		add: "Создать",
		addPackage: "Создать пакет",
		createSomePackages: "Создать несколько пакетов",
		edit: "Редактировать",
		editPackageName: "Редактировать название пакета",
		editPackageStepsAndTasks: "Редактировать шаги и задачи пакета",
		addPackageSchedule: "Добавить расписание",
		editPackageSchedule: "Редактировать расписание",
		delete: "Удалить",
		deletePackageSchedule: "Удалить расписание",
		deletePackage: "Удалить пакет",
		deletePackageByTemplate: "Удалить пакеты по шаблону",
		packageSort: "Сортировка пакетов",
		name: "Имя",
		startTime: "Время запуска",
		templateEdited: "шаблон изменен",
		schedule: "Расписание",
		steps: "Шаги",
		enterPackageName: "Введите название пакета",
		selectApps: "Выберите одно или несколько приложений",
		selectPackageCreateMode: "Выберите режим создания пакетов",
		selectPackageTemplate: "Выберите шаблон для пакета",
		enterStartTimeOfFirstPackage: "Введите время запуска первого пакета",
		enterPackageStartInterval: "Введите интервал запуска пакетов",
		thisActionDeleteScheduleOfPackage: "Это действие удалит расписание этого пакета",
		continue: "Продолжать",
		attention: "Внимание",
		cancellation: "Отмена",
		accept: "Подтвердить",
		packageWereCreatedWithoutBases: "Были созданы пакеты без введенных баз",
		fillBasesForEachPackage: "Заполните базы для каждого пакета",
		notAllRequiredFieldsSelected: "Не все обязательные поля выбраны",
		noTemplateSelected: "Не выбран ни один шаблон",
		thisActionDeleteThisPackage: "Это действие удалит этот пакет",
		enterNewPackageName: "Введите новое название пакета"
	},
	scheduleForm: {
		packageSchedule: "Расписание пакета",
		daily: "Ежедневно",
		weekly: "Еженедельно",
		dayOfWeek: "День недели",
		monthly: "Ежемесячно",
		day: "День",
		once: "Разово",
		special: "Специальное",
		blockSchedule: "Заблокировать расписание",
		cancel: "Отменить",
		monday: "Понедельник",
		tuesday: "Вторник",
		wednesday: "Среда",
		thursday: "Четверг",
		friday: "Пятница",
		saturday: "Суббота",
		sunday: "Воскресенье",
		timeNotSelected: "Не выбрано время",
		dateNotSelected: "Не выбран день",
		dayOfWeekNotSelected: "Не выбран день недели",
		specialExpressionNotSelected: "Специальное расписание не введено",
		incorrectFormat: "Расписание пакета '{name}' содержит ошибки: '{schedule}', удалите расписание и создайте его заново"
	},
	templateForm: {
		enterTemplateName: "Заполните имя шаблона",
		templateName: "Название шаблона",
		templateCreate: "Создание шаблона",
		cancel: "Отменить"
	},
	templates: {
		selected: "Выбран",
		addTemplate: "Создать",
		copyTemplate: "Копировать",
		editTemplateName: "Редактировать название шаблона",
		editTemplateTasks: "Редактировать задачи шаблона",
		activateSchedule: "Активировать расписание",
		forbidSchedule: "Запретить расписание",
		deleteTemplate: "Удалить",
		packageWithPreviousVersion: "существует пакет с прошлой версией",
		enterTemplateNewName: "Введите новое название шаблона",
		enterCopyTemplateNewName: "Введите название копии шаблона",
		accept: "Подтвердить",
		cancellation: "Отмена",
		thisActionDeleteThisTemplate: "Это действие удалит этот шаблон",
		continue: "Продолжать",
		attention: "Внимание",
		noTemplateFound: "Не найден шаблон"
	},
	templateTaskForm: {
		taskParams: "Параметры задачи",
		editTemplateTasks: "Редактирование задач шаблона",
		enterParams: "Заполнить параметры",
		cancel: "Отменить",
		taskNotSelected: "Задача не выбрана",
		youNeedEnterTaskParams: "Необходимо заполнить параметры задачи"
	}
}